// extracted by mini-css-extract-plugin
export default {"background":"AnimatedHeart_background__8ltlG"};